import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Divider } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Slide from '@mui/material/Slide';
import { GET_ONE, provider } from '../../../_utils';
import { formatReportPeriod } from '../../format';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const PaySheetModal = ({ open, onClose, paySheetId }) => {
    const [paySheetData, setPaySheetData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchPaySheet = async () => {
            if (!paySheetId || !open) return;
            
            setLoading(true);
            try {
                const { data, status } = await provider(
                    GET_ONE,
                    '/operators/reports/',
                    paySheetId
                );
                
                if (status === 200) {
                    setPaySheetData(data);
                }
            } catch (error) {
                console.error('Error fetching pay sheet:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchPaySheet();
    }, [paySheetId, open]);

    const handleClose = () => {
        setPaySheetData(null);
        if (onClose) {
            onClose();
        }
    };

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>
                Расчетный лист
            </DialogTitle>
            <DialogContent>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                        <Typography>Загрузка...</Typography>
                    </Box>
                ) : paySheetData ? (
                    <Box sx={{ mt: 2 }}>
                        <Typography variant="h6" gutterBottom>
                            {paySheetData.operator?.login || ''} {paySheetData.operator?.fullname || ''}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" gutterBottom>
                            Период: {formatReportPeriod(paySheetData.period)}
                        </Typography>
                        {(paySheetData.motivation || paySheetData.motivationVersion) && (
                            <Typography variant="body2" color="text.secondary" gutterBottom>
                                Версия мотивации: v{(paySheetData.motivation || paySheetData.motivationVersion).version}
                                {(paySheetData.motivation || paySheetData.motivationVersion).name
                                    ? ` · ${(paySheetData.motivation || paySheetData.motivationVersion).name}`
                                    : ''}
                            </Typography>
                        )}
                        <Divider sx={{ my: 2 }} />
                        {paySheetData.statistic && (
                            <Box sx={{ mb: 2 }}>
                                <Typography variant="subtitle2" gutterBottom>Статистика:</Typography>
                                <Typography variant="body2">OCC: {paySheetData.statistic.occPercent ? `${parseFloat(paySheetData.statistic.occPercent).toFixed(2)}%` : '0.00%'}</Typography>
                                <Typography variant="body2">В линии: {paySheetData.statistic.paid ? `${Math.round(paySheetData.statistic.paid / 3600 * 10) / 10} ч` : '0 ч'}</Typography>
                                <Typography variant="body2">В разговоре: {paySheetData.statistic.talkTime ? `${Math.round(paySheetData.statistic.talkTime / 3600 * 10) / 10} ч` : '0 ч'}</Typography>
                            </Box>
                        )}
                        {paySheetData.detail && (
                            <Box sx={{ mb: 2 }}>
                                <Typography variant="subtitle2" gutterBottom>Детали расчета:</Typography>
                                {paySheetData.detail.paidTime && (
                                    <Typography variant="body2">
                                        В линии: {paySheetData.detail.paidTime.time?.toFixed(2) || 0} мин × {paySheetData.detail.paidTime.tarif || 0} = {paySheetData.detail.paidTime.paid?.toFixed(2) || 0} р
                                    </Typography>
                                )}
                                {paySheetData.detail.talkTime && (
                                    <Typography variant="body2">
                                        В разговоре: {paySheetData.detail.talkTime.time?.toFixed(2) || 0} мин × {paySheetData.detail.talkTime.tarif || 0} = {paySheetData.detail.talkTime.paid?.toFixed(2) || 0} р
                                    </Typography>
                                )}
                                {paySheetData.detail.premia && (
                                    <Typography variant="body2">
                                        Премия: {paySheetData.detail.premia.percent || 0}% = {paySheetData.detail.premia.paid?.toFixed(2) || 0} р
                                    </Typography>
                                )}
                            </Box>
                        )}
                        <Divider sx={{ my: 2 }} />
                        <Typography variant="h6" color="primary">
                            Итого: {paySheetData.summa ? `${parseFloat(paySheetData.summa).toFixed(2)} р` : '0.00 р'}
                        </Typography>
                    </Box>
                ) : null}
            </DialogContent>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
                <Button onClick={handleClose} variant="contained">Закрыть</Button>
            </Box>
        </Dialog>
    );
};

export default PaySheetModal;

